import { z } from "zod";
import { CheckingAccountSchema } from "./CheckingAccount";
// import { CheckLedgerListSchema } from "./CheckLedger";

export const LedgerExportSchema = z.object({
  ledgerExportId: z.string(),
  checkingAccountId: z.string(),
  transactionType: z.string(),
  transactionMethod: z.string(),
  debitTranCode: z.string(),
  creditTranCode: z.string(),
  debitSourceCode: z.string(),
  accountNumber: z.string(),
  costCenter: z.string(),
  dDAAccount: z.string(),
  description: z.string(),
  constructionLoanAccount: z.string(),
  debitSource: z.number(),
  blockSeq: z.string(),
  equityDebitTranCode: z.string(),
  equitySourceCode: z.string(),
});

export const CheckLedgerSchema = z.object({
  ledgerId: z.string(),
  checkAction: z.string(),
  checkNumber: z.string(),
  checkDate: z.coerce.date(),
  payee: z.string(),
  projectName: z.string(),
  drawNumber: z.number(),
  comments: z.string(),
  paid: z.boolean(),
  voided: z.boolean(),
  cleared: z.boolean(),
  exported: z.boolean(),
  exportedDateStamp: z.coerce.date(),
  loanAmount: z.number(),
  equityAmount: z.number(),
  stopPayments: z.boolean(),
  stopPaymentsReason: z.string(),
  notes: z.string(),
});

export const CheckLedgerListSchema = z.array(CheckLedgerSchema);

export const LedgerExportListSchema = z.array(LedgerExportSchema);

export const LedgerDashboardSchema = z.object({
  checkingAccount: CheckingAccountSchema,
  checkLedgerList: CheckLedgerListSchema,
  ledgerExportList: LedgerExportListSchema,
});

export const InterestReserveImportSchema = z.object({
  importId: z.string(),
  status: z.string(),
  importDate: z.coerce.date(),
  dueDate: z.coerce.date(),
  projectCode: z.string(),
  projectName: z.string(),
  drawNumber: z.number(),
  budgetAmount: z.number(),
  drawAmount: z.number(),
  importAmount: z.number(),
  drawnToDate: z.number(),
  fundsAvailable: z.number(),
  maturityDate: z.coerce.date(),
  riskRating: z.string(),
});

export const InterestReserveImportResponseSchema = z.object({
  interestReserveImportResults: z.array(InterestReserveImportSchema),
  linesSkipped: z.number(),
  hasErrors: z.boolean(),
});

export const ProjectReconcileResponseSchema = z.object({
  reconcileDate: z.coerce.date(),
  linesSkipped: z.number(),
  hasErrors: z.boolean(),
});

export type LedgerDashboard = z.infer<typeof LedgerDashboardSchema>;
export type LedgerExport = z.infer<typeof LedgerExportSchema>;
export type InterestReserveImport = z.infer<typeof InterestReserveImportSchema>;
export type ProjectReconcileResponse = z.infer<typeof ProjectReconcileResponseSchema>;
export type CheckLedger = z.infer<typeof CheckLedgerSchema>;
